<div class="flex-grid">
    <aside class="col sidebar">
      <ng-content select="[sidebar]"></ng-content>
    </aside>
    <section class="col main">
      <ng-content select="[main]"></ng-content>
    </section>
</div>